import React from 'react'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { SearchFiltersToggle } from '../../components/search-filters-toggle/search-filters-toggle'
import { ValuesChangedTuple } from '../hocs/types'
import { FilterWithSelectedOptions } from '../../utils/uri.utilities'

const LeaseProductType = withFacetContext(
    FacetName.lease_product_type,
    withFilterContext(FilterName.lease_product_type, SearchFiltersToggle, {
        title: '',
        defaultSelected: true,
    })
)

export const LeaseProductTypeToggle = () => {
    const onValueChanged = (valueClicked: string[], otherFilters?: FilterWithSelectedOptions[]) => {
        if (valueClicked[0] === 'business') {
            const minLeaseMonthlyPrice = otherFilters?.find(
                (filter) => filter.filter === FilterName.min_lease_monthly_price
            )?.selected
            const maxLeaseMonthlyPrice = otherFilters?.find(
                (filter) => filter.filter === FilterName.max_lease_monthly_price
            )?.selected
            return [
                ['business'],
                [
                    { filter: FilterName.min_lease_monthly_price, selected: [] },
                    { filter: FilterName.max_lease_monthly_price, selected: [] },
                    {
                        filter: FilterName.min_lease_monthly_price_ex_vat,
                        selected: minLeaseMonthlyPrice,
                    },
                    {
                        filter: FilterName.max_lease_monthly_price_ex_vat,
                        selected: maxLeaseMonthlyPrice,
                    },
                ],
            ] as ValuesChangedTuple
        } else {
            const minLeaseMonthlyPriceExVat = otherFilters?.find(
                (filter) => filter.filter === FilterName.min_lease_monthly_price_ex_vat
            )?.selected
            const maxLeaseMonthlyPriceExVat = otherFilters?.find(
                (filter) => filter.filter === FilterName.max_lease_monthly_price_ex_vat
            )?.selected
            return [
                ['personal'],
                [
                    {
                        filter: FilterName.min_lease_monthly_price,
                        selected: minLeaseMonthlyPriceExVat,
                    },
                    {
                        filter: FilterName.max_lease_monthly_price,
                        selected: maxLeaseMonthlyPriceExVat,
                    },
                    { filter: FilterName.min_lease_monthly_price_ex_vat, selected: [] },
                    { filter: FilterName.max_lease_monthly_price_ex_vat, selected: [] },
                ],
            ] as ValuesChangedTuple
        }
    }
    return (
        <LeaseProductType
            onValueChanged={onValueChanged}
            otherFiltersToPassToOnChange={[
                FilterName.min_lease_monthly_price,
                FilterName.min_lease_monthly_price_ex_vat,
                FilterName.max_lease_monthly_price,
                FilterName.max_lease_monthly_price_ex_vat,
            ]}
        />
    )
}
